import instance, { ADMIN_PREFIX } from 'services/api';
import { BlogDetail, BlogInput, BlogListRow } from 'types/api/blog';

export interface BlogListResponse {
  data: BlogListRow[];
  total: number;
}

export interface FetchBlogListParams {
  page: number;
  limit: number;
}

export const fetchBlogList = (params: FetchBlogListParams, lang: string) =>
  instance.get<BlogListResponse>(`${ADMIN_PREFIX}/content/blogs`, {
    params,
    headers: { locale: lang }
  });

export const fetchBlogById = (id: string | number) =>
  instance.get<BlogDetail>(`${ADMIN_PREFIX}/content/blogs/${id}`);

export const createBlog = (input: BlogInput) =>
  instance.post(`${ADMIN_PREFIX}/content/blogs`, input);

export const updateBlog = (id: string | number, input: BlogInput) =>
  instance.put(`${ADMIN_PREFIX}/content/blogs/${id}`, input);

export const deleteBlog = (id: string | number) =>
  instance.delete(`${ADMIN_PREFIX}/content/blogs/${id}`);
